/**
 * Rounds a rough step up to a "nice" value (1, 2, 5 or 10 × magnitude) so axis
 * labels land on clean numbers.
 */
const niceStep = (rough: number): number => {
  const magnitude = 10 ** Math.floor(Math.log10(rough));
  const residual = rough / magnitude;

  if (residual <= 1) return magnitude;
  if (residual <= 2) return 2 * magnitude;
  if (residual <= 5) return 5 * magnitude;

  return 10 * magnitude;
};

/**
 * Computes a y-axis scale that renders exactly 5 evenly-spaced, rounded ticks
 * (0 through a "nice" maximum), so different charts share a consistent axis.
 */
export const fiveTickScale = (
  values: number[]
): { max: number; stepSize: number } => {
  const dataMax = values.length ? Math.max(0, ...values) : 0;

  if (dataMax <= 0) return { max: 4, stepSize: 1 };

  const step = niceStep(dataMax / 4);

  return { max: step * 4, stepSize: step };
};
